export const version = "wallet/5.4.0";
//# sourceMappingURL=_version.js.map